// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"548f9a59","453":"5336ca85"}[chunkId] + ".chunk.js";
};